// list of constants used by data fetch actions, reducers, sagas and withData HOC
export const dataConstants = {
    EVENTS: 'EVENTS',
    EVENT_CATEGORIES: 'EVENT_CATEGORIES',
    EVENT_OCCURRENCES: 'EVENT_OCCURRENCES',
    EVENT_ENGAGEMENTTYPES: 'EVENT_ENGAGEMENTTYPES',
    EVENT_SWIPETEAMS: 'EVENT_SWIPETEAMS',
    EVENTS_DEPARTMENTS: 'EVENT_DEPARTMENTS',

    DATA_EVENTCATEGORY_REQUEST: 'DATA_EVENTCATEGORY_REQUEST',
    DATA_EVENTCATEGORY_SUCCESS: 'DATA_EVENTCATEGORY_SUCCESS',
    DATA_EVENTCATEGORY_FAILURE: 'DATA_EVENTCATEGORY_FAILURE',

    DATA_SETEVTCATEGORY_REQUEST: 'DATA_SETEVTCATEGORY_REQUEST',
    DATA_SETEVTCATEGORY_SUCCESS: 'DATA_SETEVTCATEGORY_SUCCESS',
    DATA_SETEVTCATEGORY_FAILURE: 'DATA_SETEVTCATEGORY_FAILURE',
    DATA_SETEVTCATEGORY_CLEAR: 'DATA_SETEVTCATEGORY_CLEAR',

    DATA_ADDEVTCATEGORY_REQUEST: 'DATA_ADDEVTCATEGORY_REQUEST',
    DATA_ADDEVTCATEGORY_SUCCESS: 'DATA_ADDEVTCATEGORY_SUCCESS',
    DATA_ADDEVTCATEGORY_FAILURE: 'DATA_ADDEVTCATEGORY_FAILURE',

    DATA_UPDATEEVTCATEGORY_REQUEST: 'DATA_UPDATEEVTCATEGORY_REQUEST',
    DATA_UPDATEEVTCATEGORY_SUCCESS: 'DATA_UPDATEEVTCATEGORY_SUCCESS',
    DATA_UPDATEEVTCATEGORY_FAILURE: 'DATA_UPDATEEVTCATEGORY_FAILURE',

    DATA_DELEVTCATEGORY_REQUEST: 'DATA_DELEVTCATEGORY_REQUEST',
    DATA_DELEVTCATEGORY_SUCCESS: 'DATA_DELEVTCATEGORY_SUCCESS',
    DATA_DELEVTCATEGORY_FAILURE: 'DATA_DELEVTCATEGORY_FAILURE',

    DATA_GETEVTOCCURRENCES_REQUEST: 'DATA_GETEVTOCCURRENCES_REQUEST',
    DATA_GETEVTOCCURRENCES_SUCCESS: 'DATA_GETEVTOCCURRENCES_SUCCESS',
    DATA_GETEVTOCCURRENCES_FAILURE: 'DATA_GETEVTOCCURRENCES_FAILURE',
    DATA_GETEVTOCCURRENCES_CLEAR: 'DATA_GETEVTOCCURRENCES_CLEAR',

    DATA_ADDEVTOCCURRENCES_REQUEST: 'DATA_ADDEVTOCCURRENCES_REQUEST',
    DATA_ADDEVTOCCURRENCES_SUCCESS: 'DATA_ADDEVTOCCURRENCES_SUCCESS',
    DATA_ADDEVTOCCURRENCES_FAILURE: 'DATA_ADDEVTOCCURRENCES_FAILURE',

    DATA_UPDEVTOCCURRENCES_REQUEST: 'DATA_UPDEVTOCCURRENCES_REQUEST',
    DATA_UPDEVTOCCURRENCES_SUCCESS: 'DATA_UPDEVTOCCURRENCES_SUCCESS',
    DATA_UPDEVTOCCURRENCES_FAILURE: 'DATA_UPDEVTOCCURRENCES_FAILURE',

    DATA_DELEVTOCCURRENCES_REQUEST: 'DATA_DELEVTOCCURRENCES_REQUEST',
    DATA_DELEVTOCCURRENCES_SUCCESS: 'DATA_DELEVTOCCURRENCES_SUCCESS',
    DATA_DELEVTOCCURRENCES_FAILURE: 'DATA_DELEVTOCCURRENCES_FAILURE',

    DATA_GETEVTOCCURSWIPERS_REQUEST: 'DATA_GETEVTOCCURSWIPERS_REQUEST',
    DATA_GETEVTOCCURSWIPERS_SUCCESS: 'DATA_GETEVTOCCURSWIPERS_SUCCESS',
    DATA_GETEVTOCCURSWIPERS_FAILURE: 'DATA_GETEVTOCCURSWIPERS_FAILURE',
    DATA_GETEVTOCCURSWIPERS_CLEAR: 'DATA_GETEVTOCCURSWIPERS_CLEAR',

    DATA_UPDEVTOCCURSWIPERS_REQUEST: 'DATA_UPDEVTOCCURSWIPERS_REQUEST',
    DATA_UPDEVTOCCURSWIPERS_SUCCESS: 'DATA_UPDEVTOCCURSWIPERS_SUCCESS',
    DATA_UPDEVTOCCURSWIPERS_FAILURE: 'DATA_UPDEVTOCCURSWIPERS_FAILURE',

    DATA_EVENT_REQUEST: 'DATA_EVENT_REQUEST',
    DATA_EVENT_SUCCESS: 'DATA_EVENT_SUCCESS',
    DATA_EVENT_FAILURE: 'DATA_EVENT_FAILURE',

    DATA_OCCURRENCES_REQUEST: 'DATA_OCCURRENCES_REQUEST',
    DATA_OCCURRENCES_SUCCESS: 'DATA_OCCURRENCES_SUCCESS',
    DATA_OCCURRENCES_FAILURE: 'DATA_OCCURRENCES_FAILURE',
    DATA_OCCURRENCES_CLEAR: 'DATA_OCCURRENCES_CLEAR',

    DATA_SWIPE_REQUEST: 'DATA_SWIPE_REQUEST',
    DATA_SWIPE_SUCCESS: 'DATA_SWIPE_SUCCESS',
    DATA_SWIPE_FAILURE: 'DATA_SWIPE_FAILURE',

    DATA_GETBATCHSWIPEEMPLIDS_REQUEST: 'DATA_GETBATCHSWIPEEMPLIDS_REQUEST',
    DATA_GETBATCHSWIPEEMPLIDS_SUCCESS: 'DATA_GETBATCHSWIPEEMPLIDS_SUCCESS',
    DATA_GETBATCHSWIPEEMPLIDS_FAILURE: 'DATA_GETBATCHSWIPEEMPLIDS_FAILURE',

    DATA_BATCHSWIPEVALIDATE_REQUEST: 'DATA_BATCHSWIPEVALIDATE_REQUEST',
    DATA_BATCHSWIPEVALIDATE_SUCCESS: 'DATA_BATCHSWIPEVALIDATE_SUCCESS',
    DATA_BATCHSWIPEVALIDATE_FAILURE: 'DATA_BATCHSWIPEVALIDATE_FAILURE',
    DATA_BATCHSWIPEVALIDATE_CLEAR: 'DATA_BATCHSWIPEVALIDATE_CLEAR',

    DATA_BATCHSWIPERECORD_REQUEST: 'DATA_BATCHSWIPERECORD_REQUEST',
    DATA_BATCHSWIPERECORD_SUCCESS: 'DATA_BATCHSWIPERECORD_SUCCESS',
    DATA_BATCHSWIPERECORD_FAILURE: 'DATA_BATCHSWIPERECORD_FAILURE',

    DATA_LOOKUP_REQUEST: 'DATA_LOOKUP_REQUEST',
    DATA_LOOKUP_SUCCESS: 'DATA_LOOKUP_SUCCESS',
    DATA_LOOKUP_FAILURE: 'DATA_LOOKUP_FAILURE',
    DATA_LOOKUP_CLEARPARAMS: 'DATA_LOOKUP_CLEARPARAMS',
    DATA_LOOKUP_CLEARRESULTS: 'DATA_LOOKUP_CLEARRESULTS',

    DATA_LOOKUPEUID_REQUEST: 'DATA_LOOKUPEUID_REQUEST',
    DATA_LOOKUPEUID_SUCCESS: 'DATA_LOOKUPEUID_SUCCESS',
    DATA_LOOKUPEUID_FAILURE: 'DATA_LOOKUPEUID_FAILURE',
    DATA_LOOKUPEUID_CLEARRESULTS: 'DATA_LOOKUPEUID_CLEARRESULTS',

    DATA_GETSWIPETEAMS_REQUEST: 'DATA_GETSWIPETEAMS_REQUEST',
    DATA_GETSWIPETEAMS_SUCCESS: 'DATA_GETSWIPETEAMS_SUCCESS',
    DATA_GETSWIPETEAMS_FAILURE: 'DATA_GETSWIPETEAMS_FAILURE',

    DATA_GETDEPTSWIPETEAM_REQUEST: 'DATA_GETDEPTSWIPETEAM_REQUEST',
    DATA_GETDEPTSWIPETEAM_SUCCESS: 'DATA_GETDEPTSWIPETEAM_SUCCESS',
    DATA_GETDEPTSWIPETEAM_FAILURE: 'DATA_GETDEPTSWIPETEAM_FAILURE',
    DATA_GETDEPTSWIPETEAM_CLEARRESULTS: 'DATA_GETDEPTSWIPETEAM_CLEARRESULTS',

    DATA_ADDSWIPETEAM_REQUEST: 'DATA_ADDSWIPETEAM_REQUEST',
    DATA_ADDSWIPETEAM_SUCCESS: 'DATA_ADDSWIPETEAM_SUCCESS',
    DATA_ADDSWIPETEAM_FAILURE: 'DATA_ADDSWIPETEAM_FAILURE',

    DATA_UPDATESWIPETEAM_REQUEST: 'DATA_UPDATESWIPETEAM_REQUEST',
    DATA_UPDATESWIPETEAM_SUCCESS: 'DATA_UPDATESWIPETEAM_SUCCESS',
    DATA_UPDATESWIPETEAM_FAILURE: 'DATA_UPDATESWIPETEAM_FAILURE',

    DATA_DELETESWIPETEAM_REQUEST: 'DATA_DELETESWIPETEAM_REQUEST',
    DATA_DELETESWIPETEAM_SUCCESS: 'DATA_DELETESWIPETEAM_SUCCESS',
    DATA_DELETESWIPETEAM_FAILURE: 'DATA_DELETESWIPETEAM_FAILURE',

    DATA_ENGAGEMENTTYPE_REQUEST: 'DATA_ENGAGEMENTTYPE_REQUEST',
    DATA_ENGAGEMENTTYPE_SUCCESS: 'DATA_ENGAGEMENTTYPE_SUCCESS',
    DATA_ENGAGEMENTTYPE_FAILURE: 'DATA_ENGAGEMENTTYPE_FAILURE',

    DATA_GETSUPERADMINS_REQUEST: 'DATA_GETSUPERADMINS_REQUEST',
    DATA_GETSUPERADMINS_SUCCESS: 'DATA_GETSUPERADMINS_SUCCESS',
    DATA_GETSUPERADMINS_FAILURE: 'DATA_GETSUPERADMINS_FAILURE',

    DATA_PUTSUPERADMIN_REQUEST: 'DATA_PUTSUPERADMIN_REQUEST',
    DATA_PUTSUPERADMIN_SUCCESS: 'DATA_PUTSUPERADMIN_SUCCESS',
    DATA_PUTSUPERADMIN_FAILURE: 'DATA_PUTSUPERADMIN_FAILURE',

    DATA_DEPARTMENTS_REQUEST: 'DATA_DEPARTMENTS_REQUEST',
    DATA_DEPARTMENTS_SUCCESS: 'DATA_DEPARTMENTS_SUCCESS',
    DATA_DEPARTMENTS_FAILURE: 'DATA_DEPARTMENTS_FAILURE',

    DATA_SETACTDEPARTMENT_REQUEST: 'DATA_SETACTDEPARTMENT_REQUEST',
    DATA_SETACTDEPARTMENT_SUCCESS: 'DATA_SETACTDEPARTMENT_SUCCESS',
    DATA_SETACTDEPARTMENT_FAILURE: 'DATA_SETACTDEPARTMENT_FAILURE',

    DATA_SETMANAGEROLEDEPT_REQUEST: 'DATA_SETMANAGEROLEDEPT_REQUEST',
    DATA_SETMANAGEROLEDEPT_SUCCESS: 'DATA_SETMANAGEROLEDEPT_SUCCESS',
    DATA_SETMANAGEROLEDEPT_FAILURE: 'DATA_SETMANAGEROLEDEPT_FAILURE',
    DATA_SETMANAGEROLEDEPT_CLEAR: 'DATA_SETMANAGEROLEDEPT_CLEAR',

    DATA_ADDMANAGEROLEDEPT_REQUEST: 'DATA_ADDMANAGEROLEDEPT_REQUEST',
    DATA_ADDMANAGEROLEDEPT_SUCCESS: 'DATA_ADDMANAGEROLEDEPT_SUCCESS',
    DATA_ADDMANAGEROLEDEPT_FAILURE: 'DATA_ADDMANAGEROLEDEPT_FAILURE',

    DATA_UPDMANAGEROLEDEPT_REQUEST: 'DATA_UPDMANAGEROLEDEPT_REQUEST',
    DATA_UPDMANAGEROLEDEPT_SUCCESS: 'DATA_UPDMANAGEROLEDEPT_SUCCESS',
    DATA_UPDMANAGEROLEDEPT_FAILURE: 'DATA_UPDMANAGEROLEDEPT_FAILURE',

    DATA_DELMANAGEROLEDEPT_REQUEST: 'DATA_DELMANAGEROLEDEPT_REQUEST',
    DATA_DELMANAGEROLEDEPT_SUCCESS: 'DATA_DELMANAGEROLEDEPT_SUCCESS',
    DATA_DELMANAGEROLEDEPT_FAILURE: 'DATA_DELMANAGEROLEDEPT_FAILURE',

    DATA_GETDEPARTMENTUSERS_REQUEST: 'DATA_GETDEPARTMENTUSERS_REQUEST',
    DATA_GETDEPARTMENTUSERS_SUCCESS: 'DATA_GETDEPARTMENTUSERS_SUCCESS',
    DATA_GETDEPARTMENTUSERS_FAILURE: 'DATA_GETDEPARTMENTUSERS_FAILURE',
    DATA_GETDEPARTMENTUSERS_CLEAR: 'DATA_GETDEPARTMENTUSERS_CLEAR',

    DATA_ADDDEPARTMENTUSERS_REQUEST: 'DATA_ADDDEPARTMENTUSERS_REQUEST',
    DATA_ADDDEPARTMENTUSERS_SUCCESS: 'DATA_ADDDEPARTMENTUSERS_SUCCESS',
    DATA_ADDDEPARTMENTUSERS_FAILURE: 'DATA_ADDDEPARTMENTUSERS_FAILURE',

    DATA_UPDDEPARTMENTUSERS_REQUEST: 'DATA_UPDDEPARTMENTUSERS_REQUEST',
    DATA_UPDDEPARTMENTUSERS_SUCCESS: 'DATA_UPDDEPARTMENTUSERS_SUCCESS',
    DATA_UPDDEPARTMENTUSERS_FAILURE: 'DATA_UPDDEPARTMENTUSERS_FAILURE',

    DATA_DELDEPARTMENTUSERS_REQUEST: 'DATA_DELDEPARTMENTUSERS_REQUEST',
    DATA_DELDEPARTMENTUSERS_SUCCESS: 'DATA_DELDEPARTMENTUSERS_SUCCESS',
    DATA_DELDEPARTMENTUSERS_FAILURE: 'DATA_DELDEPARTMENTUSERS_FAILURE',

    DATA_GETALLUSERS_REQUEST: 'DATA_GETALLUSERS_REQUEST',
    DATA_GETALLUSERS_SUCCESS: 'DATA_GETALLUSERS_SUCCESS',
    DATA_GETALLUSERS_FAILURE: 'DATA_GETALLUSERS_FAILURE',
    DATA_GETALLUSERS_CLEAR: 'DATA_GETALLUSERS_CLEAR',
}
